/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductData } from './ProductData';
import {
    ProductDataFromJSON,
    ProductDataFromJSONTyped,
    ProductDataToJSON,
    ProductDataToJSONTyped,
} from './ProductData';
import type { ProductPublicationReadMetadata } from './ProductPublicationReadMetadata';
import {
    ProductPublicationReadMetadataFromJSON,
    ProductPublicationReadMetadataFromJSONTyped,
    ProductPublicationReadMetadataToJSON,
    ProductPublicationReadMetadataToJSONTyped,
} from './ProductPublicationReadMetadata';

/**
 * 
 * @export
 * @interface TopProductData
 */
export interface TopProductData {
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof TopProductData
     */
    topProductsByAmountNet?: Array<ProductData>;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof TopProductData
     */
    topProductsByTurnoverNet?: Array<ProductData>;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof TopProductData
     */
    topProductsByAmountGross?: Array<ProductData>;
    /**
     * 
     * @type {Array<ProductData>}
     * @memberof TopProductData
     */
    topProductsByTurnoverGross?: Array<ProductData>;
    /**
     * 
     * @type {number}
     * @memberof TopProductData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof TopProductData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof TopProductData
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof TopProductData
     */
    totalPages?: number;
    /**
     * 
     * @type {ProductPublicationReadMetadata}
     * @memberof TopProductData
     */
    productPublication?: ProductPublicationReadMetadata | null;
}

/**
 * Check if a given object implements the TopProductData interface.
 */
export function instanceOfTopProductData(value: object): value is TopProductData {
    return true;
}

export function TopProductDataFromJSON(json: any): TopProductData {
    return TopProductDataFromJSONTyped(json, false);
}

export function TopProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'topProductsByAmountNet': json['topProductsByAmountNet'] == null ? undefined : ((json['topProductsByAmountNet'] as Array<any>).map(ProductDataFromJSON)),
        'topProductsByTurnoverNet': json['topProductsByTurnoverNet'] == null ? undefined : ((json['topProductsByTurnoverNet'] as Array<any>).map(ProductDataFromJSON)),
        'topProductsByAmountGross': json['topProductsByAmountGross'] == null ? undefined : ((json['topProductsByAmountGross'] as Array<any>).map(ProductDataFromJSON)),
        'topProductsByTurnoverGross': json['topProductsByTurnoverGross'] == null ? undefined : ((json['topProductsByTurnoverGross'] as Array<any>).map(ProductDataFromJSON)),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalItems': json['totalItems'] == null ? undefined : json['totalItems'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'productPublication': json['productPublication'] === undefined ? undefined : json['productPublication'] === null ? null : ProductPublicationReadMetadataFromJSON(json['productPublication']),
    };
}

export function TopProductDataToJSON(json: any): TopProductData {
    return TopProductDataToJSONTyped(json, false);
}

export function TopProductDataToJSONTyped(value?: TopProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'topProductsByAmountNet': value['topProductsByAmountNet'] == null ? undefined : ((value['topProductsByAmountNet'] as Array<any>).map(ProductDataToJSON)),
        'topProductsByTurnoverNet': value['topProductsByTurnoverNet'] == null ? undefined : ((value['topProductsByTurnoverNet'] as Array<any>).map(ProductDataToJSON)),
        'topProductsByAmountGross': value['topProductsByAmountGross'] == null ? undefined : ((value['topProductsByAmountGross'] as Array<any>).map(ProductDataToJSON)),
        'topProductsByTurnoverGross': value['topProductsByTurnoverGross'] == null ? undefined : ((value['topProductsByTurnoverGross'] as Array<any>).map(ProductDataToJSON)),
        'limit': value['limit'],
        'page': value['page'],
        'totalItems': value['totalItems'],
        'totalPages': value['totalPages'],
        'productPublication': ProductPublicationReadMetadataToJSON(value['productPublication']),
    };
}

